import { useQuery } from '@src/shared/query';
import type { HolidayDate, HolidayDateDto } from '../../types';
import { holidaysUrl } from './constants';

function selectHolidays(data: HolidayDateDto[]): HolidayDate[] {
  return data.map((dto) => ({
    date: dto.date,
    branchId: dto.branch_id,
  }));
}

export type HolidayQueryParams = Partial<{
  date_from: string;
  date_to: string;
}>;

export default function useHolidays(queryParams: HolidayQueryParams = {}) {
  const { data: holidays = [], ...restQuery } = useQuery<
    HolidayDateDto[],
    HolidayDate[]
  >(holidaysUrl, {
    queryParams,
    select: selectHolidays,
    initialData: [],
    placeholderData: (previousData) => previousData,
  });

  return {
    holidays,
    ...restQuery,
  };
}
